import { Typography } from '@breetometer/components';
import { buildChatwootEmbedUrl } from 'BreetHelpers';
import { useModalApi } from 'BreetHooks';
import { useCallback, useMemo, useState } from 'react';

import Loader from '../Loader/Loader';

const DialogHelpArticle = () => {
	const { getModalProps } = useModalApi();

	const metadata = getModalProps('helpArticle')?.metadata as { url?: string } | undefined;
	const articleUrl = metadata?.url ?? '';

	const embedUrl = useMemo(() => (articleUrl ? buildChatwootEmbedUrl(articleUrl) : ''), [articleUrl]);

	const [isLoaded, setIsLoaded] = useState(false);

	const handleLoaded = useCallback(() => setIsLoaded(true), []);

	if (!articleUrl) return null;

	return (
		<div className='dialog-help-article'>
			<div className='dialog-help-article_frame-wrap scrollbar'>
				{!isLoaded && (
					<div className='dialog-help-article_loading'>
						<Loader bgClassName='theme-background-none' />
					</div>
				)}
				<iframe
					title='Help article'
					src={embedUrl}
					className='dialog-help-article_frame'
					onLoad={handleLoaded}
					loading='lazy'
					referrerPolicy='no-referrer'
				/>
			</div>

			<Typography
				as='a'
				href={articleUrl}
				target='_blank'
				rel='noopener noreferrer'
				className='dialog-help-article_fallback color-tertiary-400 tertiary-txt-link-hover'
			>
				Having trouble viewing this? Open it in your browser
			</Typography>
		</div>
	);
};

export default DialogHelpArticle;
